import API from "api/base/base";

const CsvFiles = new API({ controller: "csv_files" });

Object.assign(CsvFiles, {});

export default CsvFiles;
